const menuButton = document.getElementById("menuButton");
const menuContactWrap = document.getElementById("js-menu_layer"); // menu_contact_wrapを取得
const menuLinks = document.querySelectorAll(".menu_link");
let isMenuOpened = false;
const menuBreakpoint = 960;

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  if (isMenuOpened) {
    // メニューを開いた時の処理
    menuButton.classList.add("is-opened");
    menuContactWrap.classList.add("is-opened"); // menu_contact_wrapにクラスを追加
  } else {
    // メニューを閉じた時の処理
    menuButton.classList.remove("is-opened");
    menuContactWrap.classList.remove("is-opened"); // menu_contact_wrapのクラスを削除
  }
}

menuButton.addEventListener("click", toggleMenu);

menuLinks.forEach((menuLink) => {
  menuLink.addEventListener("click", () => {
    if (isMenuOpened) {
      toggleMenu();
    }
  });
});

if (menuContactWrap) {
  menuContactWrap.addEventListener("click", (event) => {
    // メニュー内のリンククリックを親要素でまとめて監視（イベント委譲）
    const link = event.target.closest("a");
    if (!link || !isMenuOpened) return;
    // SP時のみこの自動クローズ処理を有効化
    if (window.innerWidth > menuBreakpoint) return;

    const href = link.getAttribute("href");
    // ハッシュ付きリンク（ページ内アンカー候補）以外は何もしない
    if (!href || href.indexOf("#") === -1) return;

    let url;
    try {
      // 相対URLも含めて現在URL基準で正規化して判定する
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    // 同一ページ内アンカー（同じページ + 有効なhash）のときだけメニューを閉じる
    const isSamePage =
      url.origin === window.location.origin &&
      url.pathname.replace(/\/$/, "") === window.location.pathname.replace(/\/$/, "");
    const hasHash = url.hash && url.hash !== "#";

    if (isSamePage && hasHash) {
      toggleMenu();
    }
  });
}
